import React, {Component} from 'react'

export default class Val1 extends Component {
  render() {
    return (
      <div className="pt-20">
        <div className=" " style={{backgroundColor: '#F3F8F9', border: '1px #ffffff solid', height: '0px', marginBottom: '-3.5rem'}} />
        <div className=" grid-xl py-12 th-home--val">
          <div className=" grid-lg text-center">
            {/* <p className="h1 text-primary" style={{color: '#00d486'}}>
            Feautures
          </p> */}
            <p className="h3 th-home--mobilefonth3 text-white" style={{color: '#00414b', marginBottom: '-.03rem'}}>
              An enhanced learning experience for buyers.
            </p>
          </div>
        </div>
      </div>
    )
  }
}
